import { APP_SETTINGS } from "../../config";
import axios from "axios";

function fetchTodos(userData, token) {
  return axios.get(APP_SETTINGS.API_PATH.TODO.getEmployeeTodos, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function createTodo(userData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.addToDo, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function editToDo(userData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.editToDo, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function removeTodo(userData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.deleteToDo, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function compTodo(userData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.completeToDo, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function allUserTodo(userData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getAllUserToDo, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function postTodoCommentAPI(userData, token) {
  // console.log('inside post comment api');
  return axios.post(APP_SETTINGS.API_PATH.TODO.todoComment, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function loadWorkProgress_API(userData, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getWorkProgress, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
function addTodoFlag_API(userData, token) {
  // console.log('todo add flag api called', userData);
  return axios.post(APP_SETTINGS.API_PATH.TODO.todoFlag, userData, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function getLoggedHoursGraphDataApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getLoggedHourGraph, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
function getAllUserToDoApi(data) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getAllUserToDo, data);
}

function getTaskHourComparisonByEmpApi(data, token) {
  return axios.get(APP_SETTINGS.API_PATH.TODO.getTaskHourComparisonByEmployee, {
    params: data,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function getEmployeeRankingOnLoggedHoursApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.TODO.getEmployeeRankingOnLoggedHours,
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

function getEmployeeTasksGraphApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getEmpTasksGraph, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

function getEmpTodoTaskListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getEmpTodoTaskList, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
function getUserToDosApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.TODO.getUserToDos, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}
export {
  removeTodo,
  fetchTodos,
  createTodo,
  compTodo,
  allUserTodo,
  editToDo,
  postTodoCommentAPI,
  loadWorkProgress_API,
  addTodoFlag_API,
  getLoggedHoursGraphDataApi,
  getAllUserToDoApi,
  getTaskHourComparisonByEmpApi,
  getEmployeeRankingOnLoggedHoursApi,
  getEmployeeTasksGraphApi,
  getEmpTodoTaskListApi,
  getUserToDosApi,
};
